import type {ReactElement} from 'react';
import {ControlledSlider} from '@Components/controlled-slider';
import {useAppSelector} from '@/hooks';
import './page-slider.scss';
import {useGetNumberOfPages} from '@Hooks/poster-editor/useGetNumberOfPages';
import {onPosterPause} from '@Components/poster-editor/library/poster-editor-library';

interface PageSliderProps {
  pageId: string;
}

export function PageSlider({...props}: PageSliderProps): ReactElement | null {
  const page = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages?.pagesHashMap[props.pageId];
  });
  const isPosterVideo = useAppSelector((state) => {
    return state.posterEditor.isVideo;
  });
  const currentTime = useAppSelector((state) => {
    return state.posterEditor.currentTime;
  });
  const pageStartTime = window.posterEditor?.whiteboard?.pages.getStartTimeForPage(props.pageId) ?? 0;
  const numPages = useGetNumberOfPages();
  const isTimelineModeActive = useAppSelector((state) => {
    return state.posterEditor.isTimelineModeActive;
  });
  const setCurrentTime = (newValue: number | number[]): void => {
    void window.posterEditor?.whiteboard?.seek(newValue as number);
  };

  if (!page || !isPosterVideo) {
    return null;
  }

  if (page.duration === 0) {
    return null;
  }

  const onSlide = (value: number): void => {
    onPosterPause();
    if (numPages === 1) {
      setCurrentTime(value);
      return;
    }

    const actualTime = value + pageStartTime;
    setCurrentTime(actualTime);
  };

  return (
    <ControlledSlider
      className={`page-slider ${isTimelineModeActive ? '_hidden' : ''}`}
      value={currentTime - pageStartTime}
      step={0.01}
      min={0}
      max={page.duration}
      onSlide={onSlide}
    />
  );
}
